import React, { useEffect, useRef } from 'react'
import NavBar from '../NavBar.component'
import Slider from '../Slider.component'
import Footer from '../Footer.component'
import CustomScrollbar from '../CustomScrollbar.component'
import TabContent from '../TabContent.component'
import Clientele from '../Home/Clientele.component'
import Banner4 from "../../assets/Banner4.svg";
import Need5 from "../../assets/need-5.svg";
import NeedImg5 from "../../assets/NeedImg5.svg";
import thumbImg from '../../assets/SolutionsImage/vectorImages/1.jpg'

let css = `
    .active-tab{
        color: #fff;
        background-color: #174997;
    }
    .active-tab img{
        filter: invert(1);
    }
`;


export default function MachineLearning() {
    let scrollRef = useRef();
    const serviceBoxRef = useRef(null);

    // Scroll to the ServiceBox section when the page loads
    useEffect(() => {
        serviceBoxRef.current.scrollIntoView({ behavior: 'smooth' });
    }, []);
    return (
        <>
            <section className="">
                {/* NAVIGATION BAR */}
                <section className="">
                    <NavBar />
                </section>

                {/* NAV-CONTACT */}
                <section>{/* <NavContact/> */}</section>

                {/* HERO SLIDER */}
                <section>
                    <Slider images={[Banner4]} showDemoButton={true} />
                </section>

                {/* SOLUTION FOR YOUR UNIQUE BUSINESS NEEDS */}
                <section ref={serviceBoxRef} >
                    <section>
                        <style>{css}</style>
                        <div className="pt-16 custom-container">
                            <h1 className="text-center heading">
                                Solution for your unique business needs
                            </h1>
                            <p className="mt-3 text-sm text-center font-['montserrat']">
                                Explore our comprehensive range of solutions designed to
                                solve your specific challenges.
                            </p>
                        </div>
                        <div className="flex mb-12 mt-0 max-w-[80%] justify-center mx-auto items-center">
                            <div
                                className="p-5 max-h-[770px]  overflow-y-auto scroll-smooth"
                                ref={scrollRef}
                            >
                                <TabContent
                                    index={4}
                                    icon={Need5}
                                    thumbnail={thumbImg}
                                    title={
                                        "Machine Learning and Artificial Intelligence"
                                    }
                                    content={[
                                        "With Machine Learning (ML) and Artificial Intelligence (AI) we bring the power to revolutionize the way businesses operate in the modern world. These cutting-edge technologies are making it possible to analyze vast amounts of data and provide intelligent insights and predictions that can help drive business decisions. ML and AI algorithms are used in diverse industries, from healthcare and finance to retail and manufacturing, and can help automate mundane tasks, increase productivity, and reduce costs. With advancements in computing power and data storage capabilities, ML and AI are becoming more accessible to businesses of all sizes, unlocking new possibilities for growth and innovation.",
                                    ]}
                                    image={NeedImg5}
                                    captionWidth={"200px"}
                                />
                            </div>
                        </div>
                    </section>
                </section>

                {/* CLIENTELE */}
                <section>
                    <Clientele />
                </section>

                {/* FOOTER */}
                <section>
                    <Footer />
                </section>

                <CustomScrollbar />
            </section>
        </>
    )
}
